// extracted by mini-css-extract-plugin
export default {"tooltip":"IggUL4ysgvchsBI6216Z","date":"ZtEM6h9I3fH3uBag8W8S"};